var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({ref:"select",class:_vm.className,attrs:{"aria-invalid":_vm.invalid ? 'true' : 'false'}},'select',_vm.$attrs,false),_vm.inputListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }